class Logo extends HTMLElement {
    constructor() {
        super();
        this.stickyHeaderElement = document.querySelector('sticky-header');
        this.containerElement = document.getElementById('logo-index-container');
        this.svg = document.getElementById('svg-logo-index');
        this.currentScrollTop = 0;
        this.onScroll();
    }

    connectedCallback() {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        window.addEventListener('resize', this.onScrollHandler, false);
    }

    disconnectedCallback() {
        window.removeEventListener('scroll', this.onScrollHandler);
        window.removeEventListener('resize', this.onScrollHandler);
    }

    onScroll() {
        const scrollTop = Math.max(0, window.pageYOffset || document.documentElement.scrollTop);
        const maxScroll = this.offsetHeight;

        const factor = Math.min(scrollTop / maxScroll, 1);
        this.stickyHeaderElement.style.pointerEvents = factor < 1 ? 'none' : 'auto';
        const opacity = (Math.exp(7 * factor) - 1) / (Math.exp(7) - 1);
        this.stickyHeaderElement.style.setProperty('opacity', opacity);
        this.stickyHeaderElement.style.setProperty('border-radius', `${(1 - factor) * 25}px`);
        // this.svg.style.setProperty('stroke-width', `${factor * 4}px`);
        this.svg.style.setProperty('width', 100 - factor * 100 + '%');
        this.containerElement.style.setProperty('padding', `calc(${Math.max(1 - factor, 0.2)} * var(--space-sm))`);

        if (factor >= 1) {
            this.containerElement.classList.add('logo-index-container__fit');
        } else {
            this.containerElement.classList.remove('logo-index-container__fit');
        }

        this.currentScrollTop = scrollTop;
    }
}

customElements.define('logo-index', Logo);
